module.exports = __webpack_public_path__ + "dfbbcafacc5786ac30dabe91b8b6f949.svg";